// extracted by mini-css-extract-plugin
module.exports = {"minimumScreenWidth":"320px","mobileScreenWidth":"600px","root":"style_root__2tQJs","navigation":"style_navigation__2R4jx"};